import React, { useMemo } from 'react';
import { Input, Form } from 'antd';
import { LoginService } from '../../../service/authorization';
import { useLogin } from '../actions';

export interface AccountFormProps {
  Username: React.FunctionComponent<any>,
  Password: React.FunctionComponent<any>,
  Form: React.FunctionComponent<any>,
}

const useAccountFactory = (service: LoginService): AccountFormProps => {
  const { fields } = service;
  const StaticForm = (props: any) => {
    const [form] = Form.useForm();
    const { children, ...restProps } = props;
    const onFinish = useLogin(service);
    return (
      <Form {...restProps} form={form} onFinish={onFinish}>
        {children}
      </Form>
    )
  };
  const Username = (props: any) => {
    // Form.Item参数
    const { label, ...inputProps } = props;
    return (
      <Form.Item
        // label属性是展示用的属性，与数据处理无关，故暴露
        label={label}
        // name属性是用的属性，与数据展示无关，故隐藏
        name="username"
        rules={[{ required: true, message: inputProps.placeholder }]}
      >
        <Input {...inputProps} />
      </Form.Item>
    );
  };
  const Password = (props: any) => {
    const { label, ...inputProps } = props;
    return (
      <Form.Item
        label={label}
        name="password"
        rules={[{ required: true, message: inputProps.placeholder }]}
      >
        <Input.Password {...inputProps} />
      </Form.Item>
    );
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => ({ Password, Username, Form: StaticForm }), [fields]);
};

export default useAccountFactory;
